import { render, staticRenderFns } from "./DLLeadLabels.vue?vue&type=template&id=57e1f4de&scoped=true&"
import script from "./DLLeadLabels.vue?vue&type=script&lang=js&"
export * from "./DLLeadLabels.vue?vue&type=script&lang=js&"
import style0 from "./DLLeadLabels.vue?vue&type=style&index=0&id=57e1f4de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e1f4de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDivider,VSpacer})
